import ShopRegiTree from "./ShopRegiTree";

// コメントの有無を判定する（null・空文字・空白のみは「なし」とみなす）
const hasMessage = (row) => !!(row && row.Message && row.Message.trim() !== "");

// 未確認コメントを示すバッジ
function CommentBadge() {
  return (
    <span className="ml-1 text-red-600 font-bold text-sm" title="コメントあり">
      ！
    </span>
  );
}

/**
 * CommentTreeView - 全店舗コメント確認画面用ツリービュー
 *
 * 選択日の DailyReport.Message を店舗→レジ の2階層で表示する。
 * コメントが存在する店舗・レジのヘッダーには「！」バッジを表示し、未確認分に気付けるようにする。
 * グループ化・展開状態の管理は ShopRegiTree（AllShopsTreeView と共通基盤）に委ねている。
 *
 * @param {object[]} regiInfo - 全レジ情報 [{ShopNo, ShopName, RegiNo, RegiName}]
 * @param {object[]} reports  - 選択日を含む月の全店舗データ [{YYYYMMDD, ShopNo, RegiNo, Message, ...}]
 * @param {string}   yyyymmdd - 表示対象の日付 (YYYYMMDD形式)
 */
function CommentTreeView({ regiInfo, reports, yyyymmdd }) {
  const shops = regiInfo.filter((r) => r.ShopNo !== 0);

  const getDayReport = (shopNo, regiNo) =>
    reports.find(
      (r) =>
        r.YYYYMMDD === yyyymmdd &&
        String(r.ShopNo) === String(shopNo) &&
        String(r.RegiNo) === String(regiNo)
    ) ?? null;

  // 店舗配下のいずれかのレジにコメントがあるか
  const shopHasComment = (shopNo) =>
    shops
      .filter((r) => r.ShopNo === shopNo)
      .some((r) => hasMessage(getDayReport(shopNo, r.RegiNo)));

  return (
    <ShopRegiTree
      regiInfo={regiInfo}
      defaultExpandedShops={new Set(shops.map((r) => r.ShopNo))}
      defaultExpandedRegis={new Set()}
      renderShopBadge={(shopNo) => (shopHasComment(shopNo) ? <CommentBadge /> : null)}
      renderRegiBadge={(shopNo, regiNo) =>
        hasMessage(getDayReport(shopNo, regiNo)) ? <CommentBadge /> : null
      }
      renderRegiContent={(shopNo, regiNo) => {
        const row = getDayReport(shopNo, regiNo);
        return (
          <div className="ml-12 mt-1 mb-2 px-3 py-2 bg-white border border-gray-300 rounded text-sm max-w-2xl">
            {hasMessage(row) ? (
              <p className="whitespace-pre-wrap">{row.Message}</p>
            ) : (
              <p className="text-gray-400">コメントはありません</p>
            )}
          </div>
        );
      }}
    />
  );
}

export default CommentTreeView;
